<template>
  <div class="menu">
    <div class="menu__left">
      <div class="menu--logo">
        <router-link :to="`${parsedLocaleString}/`">
          <logo fill="#fff" />
        </router-link>
      </div>
      <div class="menu--root">
        <!--Root category links-->
        <router-link
          v-for="item in items"
          :class="[activeRoot && activeRoot.cid === item.cid ? 'active' : '']"
          :key="item.cid"
          :to="item.path"
          @[__event].native="activateRoot(item)"
        >
          {{ item.title }}
          <transition name="fader-right" appear>
            <i
              v-if="!!activeRoot && activeRoot.cid === item.cid"
              class="fal fa-chevron-right"
            ></i>
          </transition>
        </router-link>
      </div>
    </div>
    <div class="menu__right">
      <transition name="fast-fade" appear>
        <div v-if="activeRoot" class="menu--list">
          <div
            v-for="category in sortedChildren(activeRoot.children)"
            class="menu--list--category"
            :key="category.cid"
          >
            <router-link class="category-link font-rg" :to="category.path">
              <span v-text="category.title"></span>
            </router-link>
            <div v-if="hasItems(category)" class="menu--list--items">
              <router-link
                v-for="item in category.children"
                class="item-link"
                :to="item.path"
                :key="item.cid"
              >
                <span v-text="item.title"></span>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "overlay-menu",
  data() {
    return {
      activeRoot: null,
      showclose: false
    };
  },
  deactivated() {
    console.log("menu activated");
    this.showclose = false;
  },
  activated() {
    console.log("menu activated");
    // alert(this.dimensions.width)
    setTimeout(
      function() {
        this.showclose = true;
      }.bind(this),
      800
    );
  },
  detroyed() {
    console.log("menu destroyed");
    this.showclose = false;
  },
  mounted() {
    console.log("menu mounted");
    if (this.items.length && this.dimensions.width > 600) {
      this.activeRoot = this.items[0];
    }
  },
  computed: {
    ...mapState({
      items: state => state.menuItems,
      dimensions: state => state.dimensions
    }),
    ...mapGetters(["localeString"]),
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    __event() {
      return this.dimensions.width > 600 ? "mouseover" : null;
    }
  },
  methods: {
    activateRoot: _.debounce(
      function(cat) {
        if (this.activeRoot.cid !== cat.cid) {
          this.activeRoot = null;
          this.$nextTick(function() {
            this.activeRoot = cat;
          });
        }
      },
      300,
      { leading: true }
    ),
    sortedChildren(children) {
      // TEMP
      // children = _.filter(
      //   children,
      //   child => child.path.indexOf("booklets") < 0
      // );
      return _.sortBy(children, "sort");
    },
    categoryItems(cat) {
      return this.items[2].filter(item => item.pid === cat.cid);
    },
    hasItems(cat) {
      return !!cat.children && !!cat.children.length;
    }
  }
};
</script>
<style lang="stylus" scoped>
.menu
  display flex
  flex-direction row
  align-items center
  justify-content space-between
  height 100%
  width 100%
  & > *
    &:first-child
      flex 100%
    &:last-child
      display none
    +above(415px)
      height 100%
      flex 0 0 50%
      &:last-child
        display flex
.menu--logo
  position relative
  width 80%
  border-bottom 1px solid c_lt_blue
  svg
    position absolute
    bottom 2vh
    right 0
    max-width 165px
    fill #fff
	/*
		Left side of menu
	*/
.menu__left
  padding-top 30vh
  +below(815px)			
    padding-top 1vh
.menu--root
  width 80%
  display flex
  flex-direction column
  align-items flex-end
  a
    position relative
    display block
    color rgba(#fff, 0.7)
    font-size responsive 24px 30px
    line-height 1
    padding 10px 0
    will-change color
    transition color 0.3s ease-out
    +below(1400px)
      padding 6px 0
    +desktop()
      &:hover
      &.visited:hover
      &.router-link-active
        color rgba(#fff, 0.88)
  span, i
    display inline-block
    vertical-align middle
    line-height 1
  i
    font-size 55%
    top 52%
    right -45px
    position absolute
    transform translate(0, -50%)
    will-change transform
  &.active
    color rgba(#fff, 1)
  hoverize(#fff, color)

	/*
		Right side of menu
	*/
.menu__right
  // background rgba(green, 0.2)
  display flex
  justify-content flex-start
  align-items center
.menu--list
  text-align left
  max-width 90%  
  @media screen and (max-height:815px)
    column-count 2
    column-gap 20px
    column-fill auto
    max-width 95%
  &--items
    margin-top 12px
  &--category
    break-inside avoid
    &:not(:last-child)
      padding-bottom 12px
      margin-bottom 12px
      position relative
      &:after
        content ''
        height 1px
        width 16%
        background c_lt_blue
        position absolute auto auto 0 0
    .category-link
      color c_lt_blue
      text-transform uppercase
      font-size responsive 18px 22px
      font-range 1300px 1900px
      display block
      font-weight 400
      +desktop()
        transition color 0.3s ease-out
        &:hover
          color lighten(c_lt_blue, 10)
    .item-link
      font-size responsive 13px 15px
      color rgba(#fff, 0.8)
      display block
      line-height 1
      margin-bottom 2px
      +desktop()
        transition color 0.3s ease-out
        &:hover
          color rgba(#fff, 1)
.menu--list--items
  +below(600px)
    display none
  // @media screen and (max-height: 768px)
</style>
